module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.bba71598.svg";